import {Component, h} from 'preact';
import 'jquery-file-download';
import AsideRevisions from "../AsideRevisions";
import constants from "../../constants";

export default function MenuRevision({toRoot, toggleMenu}) {

  function onRevisionChange() {
    toggleMenu();
  }

  return (
    <div>
      <header className={'sb'}>
        <a onClick={toRoot}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-arrow"}/>
          </svg>
        </a>
        <h2>Saved Versions</h2>
      </header>

      <AsideRevisions hideTitle={true} onRevisionChange={onRevisionChange}/>
    </div>
  )
}
